module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound-wrapper"
  }, [_c('div', {
    staticClass: "notfound"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/suez-white.png"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("404")]), _vm._v(" "), _c('h4', [_vm._v("Cette page n'existe pas.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Retour")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a13442a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 2102
// module chunks = 2